import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';



import * as CryptoJS from 'crypto-js';
import { UserInfoService } from './user-info.service';
import { ApiRequestService } from './api-request.service';
import { LoginService } from './login.service';
import { SearchCriteriaDO,CriteriaIO } from '../../shared/models';
import { Observable, ReplaySubject, Subject } from 'rxjs';


@Injectable()
export class ChangePassService {

  constructor(
    private http: Http,
    private apiRequest: ApiRequestService, private userInfo: UserInfoService, ) { }



  changePassword(changePassParam: any): Observable<any> {
    let me = this;
    let params: URLSearchParams = new URLSearchParams();

    let userId = null;
    userId = this.userInfo.getUserId();

    let searchCriteriaList: SearchCriteriaDO[] = [];

    var searchCriteriaDO = new SearchCriteriaDO();
    searchCriteriaDO.setParamName("currenPass");
    searchCriteriaDO.setParamValue(changePassParam.currenPass);
    searchCriteriaList.push(searchCriteriaDO);

    var searchCriteriaDO1 = new SearchCriteriaDO();
    searchCriteriaDO1.setParamName("confirmPass");
    searchCriteriaDO1.setParamValue(changePassParam.confirmPass);
    searchCriteriaList.push(searchCriteriaDO1);

    var searchCriteriaDO2 = new SearchCriteriaDO();
    searchCriteriaDO2.setParamName("userId");
    searchCriteriaDO2.setParamValue(changePassParam.userId);
    searchCriteriaList.push(searchCriteriaDO2);

    var criteriaObj = new CriteriaIO();
    criteriaObj.setSearchCriteriaList(searchCriteriaList);

    let caseDataSubject = new Subject<any>(); // Will use this subject to emit data that we want

    let searchURL = 'changePassword';

    // this.apiRequest.get("changePassword" + "&confirmPass=" + confirmPass + "?currenPass=" + currPass + "?userId=" + userId)
    // this.apiRequest.post("changePassword/" + currPass + "," + confirmPass + "," + userId)

    // this.apiRequest.getServiceWithComplexObjectAsQueryString('changePassword', changePassParam)
    this.apiRequest.post(searchURL, criteriaObj)
      .subscribe(jsonResp => {

        let returnObj = jsonResp;
        caseDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
      });

    return caseDataSubject;
  }

  encrypted(plainText) {
    let ic = 1000;
    let ks = 128;



    let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);

    let pp = "metamorphosys"; //passphrase or key.
    let encrypted = this.cipherText(salt, iv, pp, plainText)
    console.log("enc =====> " + encrypted);

    // let de = this.decrypt(salt, iv, pp, encrypted);
    //console.log("decry====" + de);

    let seperator = "__babacd_dcabab__"
    let allValuesForencryption = [encrypted, iv, salt, pp, ic, ks];

    let lastString = ""
    for (var i = 0; i < allValuesForencryption.length; i++) {
      if (i !== allValuesForencryption.length - 1) {
        lastString = lastString + allValuesForencryption[i] + seperator
      } else {
        lastString = lastString + allValuesForencryption[i]
      }
    }

    return lastString;
  }


  generateKey(salt, passPhrase) {
    var key = CryptoJS.PBKDF2(
      passPhrase,
      CryptoJS.enc.Hex.parse(salt),
      { keySize: (128 / 32), iterations: 1000 });
    return key;
  }

  cipherText(salt, iv, passPhrase, plainText) {
    var key = this.generateKey(salt, passPhrase);
    var encrypted = CryptoJS.AES.encrypt(
      plainText,
      key,
      { iv: CryptoJS.enc.Hex.parse(iv) });
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  }

  decrypt(salt, iv, passPhrase, cipherText) {
    var key = this.generateKey(salt, passPhrase);
    var cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(cipherText)
    });
    var decrypted = CryptoJS.AES.decrypt(
      cipherParams,
      key,
      { iv: CryptoJS.enc.Hex.parse(iv) });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

}
